import styled from 'styled-components';

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #F7F8F9;
  display: flex;
  color: #1E2228;
`;
export const ColumnDiv = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  color: #1E2228;
  box-sizing: border-box;
  position: relative;
  overflow-y: scroll;
  @media (max-width: 992px) {
    padding: 110px 40px;
    flex-direction: column;
  }
`;
export const ContentDiv = styled.div`
  width: 100%;
  height: calc(100vh - 80px);
  overflow-x: scroll;
  padding: 0px 40px;
  margin-top: 80px;
  display: flex;
`;
export const RightDiv = styled.div`
  width: 34%;
  flex-shrink: 0;
  padding: 40px 0px;
  margin-left: 5%;
  @media (max-width: 992px) {
    width: 100%;
    margin: 0px;
  }
`;
export const LeftDiv = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 40px 0px;
`;
export const TopDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 18px;
`;
export const CompanyWrapDiv = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: normal;
  & img {
    height: 96px;
    width: 96px;
    margin-right: 24px;
  }
  & div {
    color: #1E2228;
  }
  & div:first-child {
    font-size: 28px;
    font-weight: bold;

  }
  & div:last-child {
    color: #939599;
    font-size: 12px;
    font-weight: normal;
  }
`;
export const CompanyDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 24px;
`;
export const TimeDiv = styled.div`
  display: flex;
  align-items: center;
  & img {
    height: 22px;
    width: 22px;
    margin-right: 13px;
  }
`;
export const TimeWrapDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const TimeTextDiv = styled.div`
  color: #1E2228;
  font-size: 10px;
`;
export const RemTimeDiv = styled.div`
  width: 120px;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
`;
export const InfoWrapDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const InfoDiv = styled.div`
  width: 33%;
  margin-right: 1%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 18px 0px;
  padding-right: 24px;
  & div {
    font-weight: normal;
  }
  & div:first-child {
    font-size: 10px;
    color: #939599;
    margin-bottom: 8px;
    text-transform: uppercase;
  }
  & div:last-child {
    font-size: 14px;
    color: #1E2228;
  }
  @media (max-width: 600px) {
    width: 50%;
  }
`;
export const DetailsWrapDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HeadingDiv = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin: 48px 0px 2px 0px;
`;
export const TextDiv = styled.div`
  font-size: 14px;
  font-weight: normal;
  & ul {
    list-style: disc!important;
    & li {
      margin: 12px 0px;
    }
  }
`;
export const AssessmentWrapDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: #EDF0FD;
  border-radius: 16px;
  padding: 24px;
  @media (max-width: 992px) {
    width: 100%;
    margin-top: 48px;
  }
`;
export const AssessmentHeadDiv = styled.div`
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`;
export const AssessmentDiv = styled.div`
  width: 50%;
  margin-right: 1%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 10px 0px;
  & div {
    font-weight: normal;
  }
  & div:first-child {
    font-size: 12px;
    color: #1E2228;
    margin-bottom: 2px;
  }
  & div:last-child {
    font-size: 14px;
    color: #1E2228;
    font-weight: bold;
  }
`;
